import { RegionId, UserId } from "@sp-crm/core";
import {
    useGetUsersForRegionQuery,
    useGetVisibleUsersAcrossRegionsQuery,
} from "generated/graphql";
import { useMemo } from "react";
import { stableQueryOptions } from "util/requests";
import { SpMultiSelectOption } from "./sp-multi-select";

export function useUserOptionsForRegion(
    regionId: RegionId | null,
): SpMultiSelectOption<UserId>[] {
    const query = useGetUsersForRegionQuery(
        { regionId: regionId! },
        { ...stableQueryOptions(), enabled: !!regionId },
    );

    return useMemo(() => {
        const users = query.data?.getUsersForRegion ?? [];
        return users
            .map(user => ({ id: user.id, label: user.preferredName }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [query.data]);
}

export function useUserOptionsAcrossRegions(): SpMultiSelectOption<UserId>[] {
    const query = useGetVisibleUsersAcrossRegionsQuery({}, stableQueryOptions());

    return useMemo(() => {
        const users = query.data?.getVisibleUsersAcrossRegions ?? [];
        return users
            .map(user => ({ id: user.id, label: user.preferredName }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [query.data]);
}
